import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

import AboutsPageSkeleton from "../Components/Skeleton/AboutsPageSkeleton";
import BrochurePdfViewer from "../Components/BrochurePdfViewer";
import AboutHistory from "../Components/AboutHistory";

function Brochurepage() {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  const historyRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await new Promise((resolve) => setTimeout(resolve, 600));
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!isLoading) {
      const hash = location.hash;
      if (hash) {
        setTimeout(() => {
          const el = document.querySelector(hash);
          if (el) el.scrollIntoView({ behavior: "smooth" });
        }, 0);
      }
    }
  }, [location, isLoading]);

  if (isLoading) return <AboutsPageSkeleton />;

  return (
    <>
      <Helmet>
        <title>Brochure | St Johns College Jaffna</title>
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://stjohns.microwe.net/brochure" />
      </Helmet>

      <div className="bg-header-gradient h-[144px] z-10" />

      {/* ✅ PDF section (file from public/brochure.pdf) */}
      <div id="brochure" className="py-6 md:py-10 mt-10">
        <BrochurePdfViewer file="/brochure.pdf" title="St Johns College Brochure" />
      </div>
    </>
  );
}

export default Brochurepage;